export default "//static.tradera.net/touchweb/static/output/images/category-clothes.0a7e4430.svg";